const urlParser = document.createElement('a')
import moment from 'moment'
import store from '../store'
const countries = {
  de: require('./countriesDE.json'),
  en: require('./countriesEN.json'),
  es: require('./countriesES.json')
}

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}
export function orderDate (date, mode = false) {
  let d = moment(date, 'DD.MM.YYYY HH:mm:ss')
  return mode ? d.format('HH:mm:ss') : d.format('DD.MM.YYYY')
}
export function orderDateWithoutTime (date, mode = false) {
  let d = moment(date, 'DD.MM.YYYY')
  return mode ? d.format('HH:mm:ss') : d.format('DD.MM.YYYY')
}
export function orderDateReverse (date, mode = false) {
  let d = moment(date, 'YYYY.MM.DD HH:mm:ss')
  return mode ? d.format('HH:mm:ss') : d.format('DD.MM.YYYY')
}
export function orderDateApi (date, mode = false) {
    let d = moment(date, 'YYYY-MM-DD HH:mm:ss')
    return mode ? d.format('HH:mm:ss') : d.format('DD.MM.YYYY')
}
export function fullDate (date) {
    let d = moment(date, 'YYYY-MM-DD HH:mm:ss')
    return d.format('DD.MM.YYYY HH:mm:ss')
}
export function orderTitle (title) {
  return title.length > 35 ? title.substr(0, 35) + '...' : title
}
export function merchant (title) {
  return title.length > 35 ? title.substr(0, 35) + '...' : title
}
export function currency (number = '0', symbol = '€') {

  let isPositive = number > 0 || number == 0
  if (!isPositive) {
    number *= -1
  }

  number = parseFloat(number)
  number = number.toFixed(2).replace('.', ',')

  let con = number.split(',')
  let separated = reverse(con[0]).match(/.{1,3}/g)
  let i = 0
	let final = ''
	while (i < separated.length) {
		if (i === 0) {
			final = reverse(separated[i])
		} else {
			final = final.concat('.', reverse(separated[i]))
		}i++
	}
	let b = ''
	final.split('.').reverse().forEach(x => {
		b = b + x.split().reverse()
	})
  return symbol + ' ' + (!isPositive ? '-' : '') + final.split('.').reverse().join('.').concat(',', con[1] === undefined ? '00' : con[1])
}
export function percentage (number = '0') {
  number = parseFloat(number)
  return number.toFixed(2).replace('.', ',') + ' %'
}
export function fieldNotInUse (number = '0') {
  return ('---')
}
function reverse (s) {
  return s.split('').reverse().join('')
}
export function count (arr) {
  return arr.length
}
export function dateFormat (date) {
  let d = new Date(date)
  let newDate = ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear()
  newDate += ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':'
  newDate += ('0' + d.getSeconds()).slice(-2)
  return newDate
}
export function toUpper (word) {
  return word.toUpperCase()
}
export function translate (word) {
  let json = require('./translation.json')
  let trans = json[word]
  return typeof trans === 'undefined' ? 'undefined' : trans[store.getters.language]
}
export function country (word) {
  let countries = require('./countries.json')
  return countries[word]
}
export function newCountry (word, language) {
  if (countries[language]) {
    if (word === 'all') {
      return 'All'
    } else {
      if (word === 'uk') {
        return 'United Kingdom'
      } else {
        if (word === 'deutschland') {
          return 'Germany'
        } else {
          let filter = countries[language].filter(x => {
            return x.alpha2 === word
          }).pop();
          if (!filter) {
            return word;
          }
          return filter.name
        }
      }
    }
  } else {
    return word
  }
}
export function prettyDate (date) {
  let a = new Date(date)
  return a.toDateString()
}
export function dateMonth (date) {
	let a = new Date(date)
	return translate(moment(a.getMonth()).format('MMMM'))
}
export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
export function capitalize (str) {
  if (str === 'ebay') {
    return 'eBay'
  } else if (str === 'schuhede') {
    return 'schuhe.de'
  }
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}
export function replace (str,search,replace){
  return str.replace(search,replace);
}



// WEBPACK FOOTER //
// ./src/filters/index.js